<template>
  <section>
    <!-- 操作栏 -->
    <el-row>
      <el-col :span="24" class="toolbar">
        <el-form :inline="true">
          <el-form-item label="仓库列表">
            <el-select v-model="postData.WID" placeholder="仓库列表" :disabled="!filters.IsAdmin">
              <el-option v-for="item in warehouses" :key="item.DataID" :value="item.DataID" :label="`${item.Code}  ${item.Name}`"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="盘点单状态">
            <el-select v-model="postData.Mode" placeholder="盘点单状态">
              <el-option label="全部" value="All"></el-option>
              <el-option label="未完成" value="UnComplete"></el-option>
              <el-option label="已完成" value="Complete"></el-option>
              <el-option label="取消" value="Cancel"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单号">
            <el-input v-model="postData.KeyWord" placeholder="盘点单号/来源单号"></el-input>
          </el-form-item>
          <el-form-item label="时间范围">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions2">
            </el-date-picker>
          </el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-form-item>
            <el-autocomplete   
              :fetch-suggestions="querySearchAsync"
              @select="handleSelectSearch"
              placeholder="ID / SKU / Name"
              style="width: 600px;">
            </el-autocomplete>  
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!-- 列表 -->
    <el-row>
      <el-col :span="24">
        <el-table :data="mainList" highlight-current-row stripe border>
          <el-table-column prop="DataID" label="ID"></el-table-column>
          <el-table-column prop="OrderID" label="单号"></el-table-column>
          <el-table-column prop="ReferenceID" label="来源单号"></el-table-column>
          <el-table-column label="总数 / 已盘点">
            <template slot-scope="s">
              {{s.row.Count.Quantity}} / {{s.row.Count.Inventory}}
            </template>
          </el-table-column>
          <el-table-column prop="Count.percent" label="盘点进度"></el-table-column>
          <el-table-column prop="Status" label="状态"></el-table-column>
          <el-table-column label="时间">
            <template slot-scope="s">
              {{s.row.Date}}<br/><span style="font-size:12px;color:gray;">{{s.row.UpdateDate}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="s">
              <el-button size="mini" @click="handleGetCheckDetail(s.row.DataID, 'check')">查看</el-button>
              <el-button size="mini" @click="handleGetCheckDetail(s.row.DataID, 'log')">日志</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :page-sizes="[20, 30, 50, 100]" :total="total" style="float:right;" @size-change="handleSizeChange">
        </el-pagination>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import { WPSkuSearch, getCheckList, getWarehouseList, getCheckDetail } from '../../api/api'
import util from '../../common/js/util'
import qs from 'qs'
export default {
  data () {
    return {
      // 操作栏
      postData: {
        //仓库
        WID: '', 
        // 状态
        Mode: '', 
        // 产品ID
        SkuID: '', 
        // 盘点单单号/外部单号
        KeyWord: '', 
        // 开始时间
        StartTime: '', 
        // 结束时间
        EndTime: '',
        // 页数
        Page: 0, 
        // 返回的数据量
        QueryLimitNumber: 100
      },
      // 仓库列表
      warehouses: [],
      dateRange: [],
      total: 0,
      pageSize: 50,
      pickerOptions2: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, 
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, 
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      mainList: []
    }
  },
  methods: {
    //获取仓库列表,用于搜索查询
    getWSListehouses() {
      getWarehouseList().then((res) => {
        this.warehouses = res.data.DataList
        this.filters.WID = res.data.Head.WID
        this.filters.IsAdmin = res.data.Head.IsAdmin
      })
    },
    // 搜索
    handleSearch () {
      this.getList()
    },
    getList () {
      // 处理时间段
      if (this.dateRange.length !== 0 && this.dateRange[0] !== null) {
        const formatDate = d => {
          return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
        }
        this.postData.StartTime = formatDate(this.dateRange[0])
        this.postData.EndTime = formatDate(this.dateRange[1])
      }
      getCheckList(this.postData).then(res => {
        // let _d = res.data
        let _d = {
          Ack: true,
          Message: '操作执行完成, 耗时7.81ms',
          Head: {
            Do: 'WINList',
            SkuID: 0,
            WID: 0,
            KeyWord: '',
            Mode: 'UnComplete',
            StartTime: '',
            EndTime: ''
          },
          Pagination: {
            TotalNumberOfPages: 1,
            TotalNumberOfEntries: 1,
            Page: 1,
            QueryLimitNumber: 20
          },
          Inventory: [
            {
              DataID: 1,
              OrderID: 'WIN180809HNT155',
              ReferenceID: '',
              WID: 1,
              Types: '普通',
              Status: '',
              UpdateDate: '2018-08-09 15:35:57',
              Date: '2018-08-09 15:35:57',
              Count: {
                  Quantity: 119,
                  Inventory: 0
              }
            }
          ]
        }
        if (_d.Ack) {
          this.mainList = _d.Inventory
          this.total = _d.Pagination.TotalNumberOfEntries
        } else {
          this.$message({
            type: 'error',
            message: _d.Message
          })
        }
      })
    },
    // 点击查询盘点单详情
    handleGetCheckDetail (id, type) {
      getCheckDetail({DataID: id}).then(res => {
        let _d = res.data
        if (_d.Ack) {
          this.$router.push({
            name: '/checkDetail',
            params: {
              DataID: id,
              type: type
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: _d.Message
          })
        }
      })
    },
    handleSizeChange () {},
    handleCurrentChange () {},
    //搜索
    //queryString 为在框中输入的值
    //callback 回调函数,将处理好的数据推回
    querySearchAsync(queryString, callback) {
      // if (!queryString) {
      //   this.filters.SkuID = ''
      //   return
      // }
      let para = qs.stringify({
        KeyWord: queryString
      });
      var list = [{}]
      //从后台获取到对象数组
      WPSkuSearch(para).then(res => {  
        //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示  
        for(let i of res.data.DataList){  
            i.value  = '[' + i.Status + ']' + '[' + i.FullSKU + ']' + i.FullName //将CUSTOMER_NAME作为value  
        }  
        list = res.data.DataList
        callback(list)
      }).catch(error => {  
        console.log(error)
      });  
    },
    //搜索栏选中后的处理函数
    handleSelectSearch(item) {  
      this.SkuID = item.DataID
      this.getList()
    }
  },
  mounted () {
    // 获取仓库数据
    this.getWSListehouses()
    // 获取列表数据
    this.getList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// checkList.vue?e5ee1faa